import { memo } from "react";

import { type TTailwindString, tw } from "classnames";

export type IconName =
  | "arrow"
  | "arrow-down"
  | "arrowhead"
  | "calendar"
  | "caret"
  | "checkmark"
  | "close"
  | "dropdown-arrow"
  | "exclamation-circle"
  | "facebook"
  | "filter"
  | "flag-australia"
  | "flag-canada"
  | "flag-united-kingdom"
  | "flag-united-states"
  | "flag-france"
  | "gift"
  | "instagram"
  | "loading-wheel"
  | "minus"
  | "pause"
  | "play"
  | "play-circle"
  | "plus"
  | "quick-add"
  | "search"
  | "star-empty"
  | "star-full"
  | "star-half-full"
  | "swatch-jal-meokkesseumnida"
  | "swatch-noosh-e-joon"
  | "swatch-sahtein"
  | "tiktok"
  | "trash";

interface Props {
  className?: TTailwindString;
  name: IconName;
}

const IconBase = ({ className = tw("w-8", "h-8"), name }: Props) => {
  return (
    <svg aria-hidden="true" className={tw("pointer-events-none", className)}>
      <use xlinkHref={`#${name}`} />
    </svg>
  );
};

export const Icon = memo(IconBase);
